import React from 'react'
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine'
import { useMediaQuery } from '../hooks/useMediaQuery'
import { ReactComponent as Check } from './assets/check.svg'
import { ReactComponent as DownloadApple } from './assets/download_apple.svg'
import { ReactComponent as DownloadGoogle } from './assets/download_google.svg'
import clsx from 'clsx'
import style from './block.module.scss'

interface PromoteMobileAppProps {
    apple: string
    google: string
}

const PromoteMobileApp: React.FC<PromoteMobileAppProps> = ({ apple, google }) => {
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')

    return (
        <BlockWrapper.Div className={clsx(style.block, 'content-width', isMobile && style.mobile)}>
            {!isMobile ? (
                <div className={style.content}>
                    <div className={style.titleContainer}>
                        <span className={style.title}>Téléchargez l'application officielle</span>
                        <span className={style.subtitle}>
                            de la fédération française de handball
                        </span>
                    </div>
                    <ul className={style.features}>
                        <li>
                            <Check />
                            Accédez à votre espace licencié et retrouvez toutes vos statistiques.
                        </li>
                        <li>
                            <Check />
                            Retrouvez tous les résultats, classements, calendriers et statistiques.
                        </li>
                        <li>
                            <Check />
                            Participez aux événements et venez supporter votre équipe.
                        </li>
                    </ul>

                    <div className={style.download}>
                        <a href={apple ?? '#'} target="_blank" rel="noreferrer">
                            <DownloadApple className={style.apple} />
                        </a>
                        <a href={google ?? '#'} target="_blank" rel="noreferrer">
                            <DownloadGoogle className={style.google} />
                        </a>
                    </div>
                </div>
            ) : (
                <div className={style.mobileContent}>
                    <div className={style.titleContainer}>
                        <span className={style.title}>
                            Découvrez l’application officielle&nbsp;
                        </span>
                        <span className={style.titleBold}>
                            de la fédération française de handball
                        </span>
                    </div>

                    <div className={style.download}>
                        <a href={apple ?? '#'} target="_blank" rel="noreferrer">
                            <DownloadApple className={style.apple} />
                        </a>
                        <a href={google ?? '#'} target="_blank" rel="noreferrer">
                            <DownloadGoogle className={style.google} />
                        </a>
                    </div>
                </div>
            )}
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: PromoteMobileApp,
    setup: {
        title: 'Promote Mobile App',
    },
})
